import styled from 'styled-components';
import { Drawer as AntDrawer } from 'antd';
import { COLORS } from '@/theme';

export const StyledDrawer = styled(AntDrawer)`
  .ant-drawer-content {
    background-color: rgba(18, 18, 18, 0.7);
    backdrop-filter: blur(10px);
    color: ${COLORS.BLACK_PRIMARY};
    box-shadow: 0 4px 8px ${COLORS.GREY};
    border-radius: 0.5rem;

    .ant-drawer-header {
      background-color: rgba(35, 35, 35, 0.8);
      backdrop-filter: blur(10px);
      border-bottom: 1px solid ${COLORS.DARK_GRAY};
    }

    .ant-drawer-title {
      color: ${COLORS.WHITE};
      font-size: 1.2rem;
    }

    .ant-drawer-close {
      color: ${COLORS.WHITE};
      font-size: 1.2rem;
      transition: color 0.3s;
    }
  }

  .ant-drawer-body {
    padding: 1.5rem;
    color: ${COLORS.WHITE};
    font-size: 1rem;
  }
`;
